import './ProductsB.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { Button } from '../Button';
import { Container } from '../Container';
import { ProductTile } from '../ProductTile';

export interface ProductsBContentType {
  assetList?: b2x.contentTypes.ContentSectionList<{
    asset?: b2x.contentTypes.AssetContentSectionV2;
  }>;
  mainComponent?: boolean;
  product?: string;
  title?: string;
  variant?: string;
}

interface ProductsBProps extends ProductsBContentType {}

export const ProductsB = ({ assetList, mainComponent, product, title, variant }: ProductsBProps) => {
  const light = variant === 'light';

  return (
    <b2x.Div className={classnames('products-b', variant)}>
      <Container>
        <b2x.Row gap={3}>
          {title && (
            <b2x.Col size={12}>
              <b2x.ConditionalWrapper
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                condition={title !== undefined}
                wrapper={
                  mainComponent ? (
                    <b2x.H1 className="title" fontWeight={700} margin={0} />
                  ) : (
                    <b2x.P className="title" fontWeight={700} margin={0} />
                  )
                }
              >
                {b2x.formatHtml(title)}
              </b2x.ConditionalWrapper>
            </b2x.Col>
          )}
          {product && (
            <b2x.Col size={{ lg: 3, md: 5, xs: 12 }}>
              <b2x.ProductById id={product}>
                {(_product) =>
                  _product !== undefined && (
                    <b2x.EqualHeight>
                      <b2x.Listing name={`product-${product}`} products={[_product]}>
                        <ProductTile light={light} product={_product} />
                      </b2x.Listing>
                    </b2x.EqualHeight>
                  )
                }
              </b2x.ProductById>
            </b2x.Col>
          )}
          <b2x.Col size={{ lg: 9, md: 7, xs: 12 }}>
            <b2x.SwiperContext>
              {({ navigationNextElRef, navigationPrevElRef, swiper }) => (
                <b2x.Div style={{ position: 'relative' }}>
                  <b2x.Swiper
                    breakpoints={{
                      lg: {
                        slidesPerView: 2.3,
                        spaceBetween: 16,
                      },
                      md: {
                        slidesPerView: 1.3,
                        spaceBetween: 16,
                      },
                      xl: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                      },
                      xs: {
                        slidesPerView: 1,
                        spaceBetween: 16,
                      },
                    }}
                    navigation={{ custom: true }}
                    slides={assetList?.map(({ asset, contentSectionId }) => (
                      <b2x.Div key={contentSectionId}>
                        <b2x.AssetV2 {...asset} fluid />
                      </b2x.Div>
                    ))}
                    slidesPerView={3}
                  />
                  <b2x.Div className="navigation-container">
                    <Button
                      iconStart={{ name: 'light-arrow-left', size: 20 }}
                      innerRef={navigationPrevElRef}
                      variant="blank"
                    />
                    <Button
                      iconStart={{ name: 'light-arrow-right', size: 20 }}
                      innerRef={navigationNextElRef}
                      variant="blank"
                    />
                  </b2x.Div>
                </b2x.Div>
              )}
            </b2x.SwiperContext>
          </b2x.Col>
        </b2x.Row>
      </Container>
    </b2x.Div>
  );
};
